import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { GiftOrderDetail, GiftOrderForm } from './types'
import { $params } from '../../../../features/router'
import { EGiftOrderStatusesCodes } from '../const'

export const giftOrderMounted = createEvent()
export const setGiftOrder = createEvent<GiftOrderDetail>()
export const submitEditGiftOrder = createEvent<GiftOrderDetail>()
export const $giftOrder = restore(setGiftOrder, {
  id: 0,
  orderDate: '',
  clientId: 0,
  client: {
    clientId: 0,
    crown: '',
    fullName: '',
  },
  gift: {
    id: 0,
    name: '',
    title: '',
    costPrice: '',
  },
  giftId: 0,
  giftPrice: 0,
  deliveryInfo: {
    address: '',
    contact_number: '',
    country: '',
    first_name: '',
    last_name: '',
  },
  costPrice: '',
  shippingPrice: '',
})
export const getGiftOrder = fx<void, GiftOrderDetail>({
  method: 'GET',
  url: '/giftshop/gift_order/',
})

export const updateGiftOrder = fx<GiftOrderForm, GiftOrderDetail>({
  method: 'PUT',
  url: '/giftshop/gift_order/',
})

sample({
  clock: giftOrderMounted,
  source: $params,
  fn: (params) => {
    return {
      url: `/giftshop/gift_order/${params?.giftOrderID}`,
    }
  },
  target: getGiftOrder,
})

sample({
  clock: [getGiftOrder.doneData, updateGiftOrder.doneData],
  fn: (doneData) => doneData.body,
  target: [setGiftOrder],
})

sample({
  //@ts-ignores
  clock: submitEditGiftOrder,
  source: $params,
  fn: (params, gift) => {
    let body: {} = {
      costPrice: gift.costPrice,
      shippingPrice: gift.shippingPrice,
    }
    if (gift.deliveryInfo) {
      body = {
        costPrice: gift.costPrice,
        shippingPrice: gift.shippingPrice,
        deliveryInfo: {
          address: gift.deliveryInfo.address,
          contact_number: gift.deliveryInfo.contact_number,
          country: gift.deliveryInfo.country,
          first_name: gift.deliveryInfo.first_name,
          last_name: gift.deliveryInfo.last_name,
        },
      }
    }
    return {
      url: `/giftshop/gift_order/${params?.giftOrderID}`,
      body: body,
    }
  },
  target: updateGiftOrder,
})
